import axios from 'axios';
import { message } from 'antd';
import localStorage from '../../../../utils/localStorage';
import { API_DEVICE, MAXIMOASSET, GETUSERLIST } from '../../../../commons/api';

export const getList = (url, Module) => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');

  let headers = {
    method: 'GET',
    url: `${url}?SiteId=${siteId}&Module=${Module}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(headers)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (
        (err.response && err.response.status === 400) ||
        (err.response && err.response.status === 500)
      ) {
        message.error(err.response.data.message);
      }
      return [];
    });
};

export async function getMasterList(url, Module,Type) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Object = {};
  Object = {
    method: 'GET',
    url: `${url}?SiteId=${siteId}&Module=${Module}&Type=${Type}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };

  return axios(Object)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.error(err.response.data.message);
      }
      return [];
    });
}

export async function getUsersList() {
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  let data = {
    url: `${GETUSERLIST.LIST}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: Authorization
    }
  };
  return axios(data)
    .then((response) => {
      return response.data;
    })

    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.error(err.response.data.message);
      }
      return [];
    });
}
export const getListById = (url, payload) => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let headers = {
    method: 'POST',
    url: `${url}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: payload
  };
  return axios(headers)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.error(err.response.data.message);
      }
      return [];
    });
};
export const getListByType = (url, payload) => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let headers = {
    method: 'POST',
    url: `${url}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: payload
  };
  return axios(headers)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.error(err.response.data.message);
      }
      return [];
    });
};
export const submit = (url, payload) => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');

  let headers = {
    method: 'POST',
    url: `${url}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    data: payload
  };
  return axios(headers)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const getHierarchyFromAPI = (Module,TypeValue) => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');

  let headers = {
    method: 'GET',
    url: `${MAXIMOASSET.GetMaximoHierarchy}?Module=${Module}&SiteId=${siteId}&Type=${TypeValue}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(headers)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const getHierarchyFromAPIForAsset = (Module, TypeValue) => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let headers = {
    method: 'GET',
    url: `${MAXIMOASSET.AssetModule}?SiteId=${siteId}&Module=${Module}&Type=${TypeValue}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(headers)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};
export const getDeviceList = () => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let headers = {
    method: 'GET',
    url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(headers)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.error(err.response.data.message);
      }
      return [];
    });
};
